// extracted by mini-css-extract-plugin
export default {"change_password__wrapper":"styles_change_password__wrapper__ZZFja"};